<script setup lang="ts">
import { TirPmButton, TirPmButtonVariantEnum, TirPmInput } from "tir-components";
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from "vue";
import { AdapterService } from "../adapter";
import { WeeekOptionsUpdateApiKeyRequest } from "../models";
import { CheckIcon } from "tir-style-system/icons/outline";

/**Адаптер */
const adapter = new AdapterService();

/**Параметры */
const props = defineProps({
  /**ID проекта */
  projectId: { type: Number },
  /**ApiKey */
  apiKey: { type: String },
});
/**События */
const emit = defineEmits<{
  /**Обновление апи ключа */
  updateApiKey: [state: String];
  /**Обновление настроек проекта */
  updateProjectSettings: [];
}>();

/**Загрузка */
const isLoading = ref(false);
/**Удачное обновление апи ключа */
const isSucceessUpdateApiKey = ref();
/**Данные инпута */
const inputData = ref("");

/**Отличается ли текущая данная инпута с прошлой */
const isInputChanged = computed(() => props.apiKey == inputData.value || inputData.value == "");

/**При обновлении apiKey */
watch(() => props.apiKey, setInputData, { immediate: true });

/**Изменение данных инпута */
function setInputData() {
  inputData.value = props.apiKey;
}
/**Обновить ключ апи */
const updateKeyApi = async () => {
  isLoading.value = true;
  const response = await adapter.updateApiKeyAsync(
    new WeeekOptionsUpdateApiKeyRequest({
      ProjectId: props.projectId,
      ApiKey: inputData.value,
    }),
  );
  if (response.IsSuccess) {
    isSucceessUpdateApiKey.value = true;
    emit("updateApiKey", inputData.value);
    emit("updateProjectSettings");
  }
  isLoading.value = false;
};
</script>
<template>
  <div>
    <div class="weeek-settings-token__block">
      <TirPmInput
        class="weeek-settings-token__input"
        label="Ключ для авторизации токена"
        v-model="inputData"
        :isWithHint="false"
      >
        <template v-if="isSucceessUpdateApiKey" #rightInputAddons>
          <CheckIcon class="weeek-settings-token__icon" />
        </template>
      </TirPmInput>
      <TirPmButton
        :variant="TirPmButtonVariantEnum.SecondaryState"
        :isDisabled="isInputChanged"
        :isLoading="isLoading"
        @click="updateKeyApi"
      >
        Сохранить
      </TirPmButton>
    </div>
  </div>
</template>
<style scoped lang="scss">
.weeek-settings-token {
  &__block {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  &__icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  &__input {
    width: 100%;
  }
}
</style>
